// extracted by mini-css-extract-plugin
export var logo = "_im-2";
export var logoWrapper = "_im-1";
export var strip = "_im-0";